import { render, staticRenderFns } from "./notice-bell.vue?vue&type=template&id=2894f741"
import script from "./notice-bell.vue?vue&type=script&lang=js"
export * from "./notice-bell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports